import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Tick, Alert } from '../../../assets/validation';
import './styles.css';

const Validation = ({ errorMessages, successMessage, dirty }) => {
  const errorMessage = errorMessages.join(' ');
  const inValid = !!errorMessage.trim();
  return (
    <Fragment>
      {inValid && dirty !== undefined && dirty && (
        <div className="ModalForm__Validation__root ModalForm__Validation__alert">
          <span className="ModalForm__Validation__message">{errorMessage}</span>
          <span className="ModalForm__Validation__icon">
            <Alert />
          </span>
        </div>
      )}

      {!inValid && dirty !== undefined && dirty && (
        <div className="ModalForm__Validation__root ModalForm__Validation__success">
          {successMessage && (
            <span className="ModalForm__Validation__message">
              {successMessage}
            </span>
          )}
          <span className="ModalForm__Validation__icon">
            <Tick />
          </span>
        </div>
      )}
    </Fragment>
  );
};

Validation.propTypes = {
  errorMessages: PropTypes.arrayOf(PropTypes.string),
  successMessage: PropTypes.string,
  dirty: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

Validation.defaultProps = {
  errorMessages: [],
  successMessage: undefined,
  dirty: undefined,
};
export default Validation;
